export const BET_BUILDER_ADD_BETS = 'bet-builder:add-bets';
export const BET_BUILDER_REMOVE_BETS = 'bet-builder:remove-bets';
export const BET_BUILDER_RECALCULATE = 'bet-builder:recalculate';
export const BET_BUILDER_DISABLE = 'bet-builder:disable';
export const BET_BUILDER_ACCEPT_ODDS_CHANGES = 'bet-builder:acceptOddsChanges';
export const BET_BUILDER_CHANGE_CULTURE = 'bet-builder:change-culture';
export const BET_BUILDER_CLEAR_ALL = 'bet-builder:clear-all';
export const BET_BUILDER_REMOVE_EVENT = 'bet-builder:remove-event';
export const BET_BUILDER_UPDATE_CONFIG = 'bet-builder:update-config';
export const ADD_BETS = 'ADD_BETS';
export const REMOVE_BETS = 'REMOVE_BETS';
export const REMOVE_EVENT = 'REMOVE_EVENT';
export const REMOVE_EVENT_BETS = 'REMOVE_EVENT_BETS';
export const CLEAR_ALL = 'CLEAR_ALL';
export const SET_TOTAL_ODDS = 'SET_TOTAL_ODDS';
export const RESTORE_STATE = 'RESTORE_STATE';
export const DISABLE = 'DISABLE';
export const CHANGE_CULTURE = 'CHANGE_CULTURE';
export const CALCULATE_END = 'CALCULATE_END';
export const ODDS_CHANGED = 'ODDS_CHANGED';
export const ACCEPT_ODDS_CHANGES = 'ACCEPT_ODDS_CHANGES';
export const RECALCULATE = 'RECALCULATE';
export const REMOVE_ON_ERROR = 'REMOVE_ON_ERROR';
export const SHOW_ON_SUCCESS = 'SHOW_ON_SUCCESS';
export const UPDATE_CONFIG = 'UPDATE_CONFIG';